// Global state to track desert effects
let meltingBars = new Map();
let sandwormState = { active: false, position: 0, direction: 1, timer: 0, burrowDepth: 0, segments: [] };
let scavengerState = { active: false, x: 0, y: 0, timer: 0, miningTimer: 0, targetBoulder: null };
let boulders = [];
let lastTime = 0;

export function initializeDesertState(dataArray, width, height) {
  // Only initialize if not already done
  if (meltingBars.size > 0) return;
  
  // Initialize melting bars state
  for (let i = 0; i < dataArray.length; i++) {
    meltingBars.set(i, { melting: false, meltAmount: 0, meltTimer: 0 });
  }
  
  // Initialize realistic rock formations
  boulders = [];
  for (let i = 0; i < 8; i++) {
    boulders.push({
      x: Math.random() * width,
      y: height * 0.3 + Math.random() * height * 0.4,
      width: 20 + Math.random() * 35,
      height: 15 + Math.random() * 25,
      hue: 25 + Math.random() * 30, // Rocky brown colors
      mined: false,
      rockType: Math.floor(Math.random() * 3), // Different rock shapes
      cracks: generateRockCracks()
    });
  }
  
  // Initialize sandworm segments for massive creature
  sandwormState.segments = [];
  for (let i = 0; i < 20; i++) {
    sandwormState.segments.push({
      x: 0,
      y: 0,
      size: 0,
      angle: 0
    });
  }
}

export function updateDesertState(time) {
  const deltaTime = time - lastTime;
  lastTime = time;
  return deltaTime;
}

export function generateRockCracks() {
  const cracks = [];
  const crackCount = 2 + Math.floor(Math.random() * 4);
  for (let i = 0; i < crackCount; i++) {
    cracks.push({
      startX: Math.random(),
      startY: Math.random(),
      endX: Math.random(),
      endY: Math.random(),
      width: 1 + Math.random() * 2
    });
  }
  return cracks;
}

// State getters and setters
export function getMeltingBars() {
  return meltingBars;
}

export function setMeltingBar(index, state) {
  meltingBars.set(index, state);
}

export function getSandwormState() {
  return sandwormState;
}

export function setSandwormState(newState) {
  Object.assign(sandwormState, newState);
}

export function getScavengerState() {
  return scavengerState;
}

export function setScavengerState(newState) {
  Object.assign(scavengerState, newState);
}

export function getBoulders() {
  return boulders;
}

export function setBoulders(newBoulders) {
  boulders = newBoulders;
}